
export const SET_HRES8AX_COLUMNS = 'SET_HRES8AX_COLUMNS'
export const GET_HRES8AX_COLUMNS = 'GET_HRES8AX_COLUMNS'
export const SET_HRES8AX_LABELS = 'SET_HRES8AX_LABELS'
export const GET_HRES8AX_LABELS = 'GET_HRES8AX_LABELS'

export const RECEIVED_HRES8AX_COLUMNS_LABELS = 'RECEIVED_HRES8AX_COLUMNS_LABELS'
export const SET_HRES8AX_DETAIL_INDEX = 'SET_HRES8AX_DETAIL_INDEX'
export const GET_HRES8AX_DETAIL_INDEX = 'GET_HRES8AX_DETAIL_INDEX'
export const SET_HRES8AX_DETAIL_SALARY = 'SET_HRES8AX_DETAIL_SALARY'
export const GET_HRES8AX_DETAIL_SALARY = 'GET_HRES8AX_DETAIL_SALARY'
export const SET_HRES8AX_DETAIL_DEDUCTION = 'SET_HRES8AX_DETAIL_DEDUCTION'
export const GET_HRES8AX_DETAIL_DEDUCTION = 'GET_HRES8AX_DETAIL_DEDUCTION'
export const SET_HRES8AX_DETAIL_INVEST = 'SET_HRES8AX_DETAIL_INVEST'
export const GET_HRES8AX_DETAIL_INVEST = 'GET_HRES8AX_DETAIL_INVEST'
export const SET_HRES8AX_DETAIL_CALTAX = 'SET_HRES8AX_DETAIL_CALTAX'
export const GET_HRES8AX_DETAIL_CALTAX = 'GET_HRES8AX_DETAIL_CALTAX'
export const GET_HRES8AX_DETAIL_DEDUCTION_SELECTED = 'GET_HRES8AX_DETAIL_DEDUCTION_SELECTED'
export const SET_HRES8AX_DETAIL_DEDUCTION_SELECTED = 'SET_HRES8AX_DETAIL_DEDUCTION_SELECTED'
export const GET_HRES8AX_DETAIL_DEDUCTION_POPUP = 'GET_HRES8AX_DETAIL_DEDUCTION_POPUP'
export const SET_HRES8AX_DETAIL_DEDUCTION_POPUP = 'SET_HRES8AX_DETAIL_DEDUCTION_POPUP'
export const RECEIVED_HRES8AX_DETAIL_INDEX = 'RECEIVED_HRES8AX_DETAIL_INDEX'
export const RECEIVED_HRES8AX_DETAIL_SALARY = 'RECEIVED_HRES8AX_DETAIL_SALARY'
export const RECEIVED_HRES8AX_DETAIL_DEDUCTION = 'RECEIVED_HRES8AX_DETAIL_DEDUCTION'
export const RECEIVED_HRES8AX_DETAIL_INVEST = 'RECEIVED_HRES8AX_DETAIL_INVEST'
export const RECEIVED_HRES8AX_DETAIL_CALTAX = 'RECEIVED_HRES8AX_DETAIL_CALTAX'
export const RECEIVED_HRES8AX_DETAIL_DEDUCTION_POPUP = 'RECEIVED_HRES8AX_DETAIL_DEDUCTION_POPUP'
export const SAVE_HRES8AX_SALARY_SAVE = 'SAVE_HRES8AX_SALARY_SAVE'
export const SAVE_HRES8AX_DEDUCTION_SAVE = 'SAVE_HRES8AX_DEDUCTION_SAVE'
export const SAVE_HRES8AX_INVEST_SAVE = 'SAVE_HRES8AX_INVEST_SAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres8ax/mutation-types.js